import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aaf2ac6e&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=aaf2ac6e&lang=postcss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf2ac6e",
  null
  
)

export default component.exports